<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog accounting-account-balance-spread-sheet"
        top="10vh"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">科目餘額明細</template>

        <div class="detail-row">
            <div class="summary">
                <div class="info-block">
                    <div class="label">查詢科目</div>
                    <div class="value">{{ `${accno} ${accnam}` }}</div>
                </div>
                <div class="info-block">
                    <div class="label">日期範圍</div>
                    <div class="value">{{ getDateRange }}</div>
                </div>
                <div class="info-block">
                    <div class="label">傳票張數</div>
                    <div class="value">{{ totalDataCount - 1 }}</div>
                </div>
            </div>
            <el-table :data="datas" v-loading="isLoading" empty-text="查無資料" size="small" :row-class-name="rowClassName" class="accounting-general-ledger-table">
                <el-table-column prop="accno" label="科目代號" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.firstAccno">{{ scope.row.accno }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="accnam" label="科目名稱" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.firstAccno">{{ scope.row.accnam }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="dC_TYP" label="科目屬性" width="80">
                    <template slot-scope="scope">
                        <div>
                            <span v-if="scope.row.dC_TYP === 1" class="accouting-dc-label dr">借</span>
                            <span v-else class="accouting-dc-label cr">貸</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="dat" label="傳票日期" width="105">
                    <template slot-scope="scope">
                        <div v-if="scope.row.dat">{{ getChtDate(scope.row.dat) }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="vono" label="傳票號碼" width="110">
                    <template slot-scope="scope">
                        <el-button type="text" @click="onVonoClick(scope.row.vono)">{{ scope.row.serialNumber }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="摘要" show-overflow-tooltip />
                <el-table-column prop="crD_NTD" label="借方金額" width="130" align="right">
                    <template slot-scope="scope">
                        <Money :v="scope.row.crD_NTD" v-if="scope.row.crD_NTD !== 0" />
                    </template>
                </el-table-column>
                <el-table-column prop="deB_NTD" label="貸方金額" width="130" align="right">
                    <template slot-scope="scope">
                        <Money :v="scope.row.deB_NTD" v-if="scope.row.deB_NTD !== 0" />
                    </template>
                </el-table-column>
                <el-table-column prop="crD_Balance" label="餘額" width="130" align="right">
                    <template slot-scope="scope">
                        <Money v-if="scope.row.dC_TYP === 1" :v="scope.row.crD_Balance" />
                        <Money v-if="scope.row.dC_TYP === 2" :v="scope.row.deB_Balance" />
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination layout="prev, pager, next" :page-size.sync="queryParams.PageSize" :total.sync="totalDataCount" :current-page.sync="queryParams.PageNum" @current-change="updateData">
                </el-pagination>
            </div>
        </div>

        <VoucherDetail :visible="voucherDetail.visible" :vono="voucherDetail.vono" @close="onVoucherDetailCLose" />
    </el-dialog>
</template>

<script>
import qs from 'qs';
import moment from 'moment';
import VoucherDetail from '@/components/dashboard/Accounting/AccountingVoucherList/ui/VoucherDetail.vue';

export default {
    props: {
        visible: Boolean,
        StartDate: [Number, String],
        EndDate: [Number, String],
        poo: Array,
        accno: String,
        accnam: String,
    },
    components: { VoucherDetail },
    computed: {
        getDateRange() {
            const START_YEAR = this.StartDate
                ? moment(+this.StartDate).year() - 1911
                : moment(+this.EndDate)
                    .startOf('year')
                    .year() - 1911;
            const START_DATE = this.StartDate
                ? moment(+this.StartDate).format('MM-DD')
                : moment(+this.EndDate)
                    .startOf('year')
                    .format('MM-DD');
            const END_YEAR = moment(+this.EndDate).year() - 1911;
            const END_DATE = moment(+this.EndDate).format('MM-DD');

            return `${START_YEAR}-${START_DATE} ~ ${END_YEAR}-${END_DATE}`;
        },
    },
    data() {
        return {
            datas: [],
            queryParams: {
                PageSize: 25,
                PageNum: 1,
            },
            totalDataCount: 0,
            isLoading: false,
            voucherDetail: {
                visible: false,
                transactionType: null,
                vono: null,
            },

            isEdited: false,
        };
    },
    methods: {
        onOpen() {
            this.queryParams.PageNum = 1;
            this.isEdited = false;
            this.updateData();
        },
        onBeforeClose() {
            this.$emit('close', this.isEdited);
        },

        async updateData() {
            this.isLoading = true;
            try {
                // const { query, resetQuery } = this.getManualQuery(this.queryParams);
                const resp = await this.$api({
                    url: '/AccountingSummaryReport/QueryGeneralLedger',
                    method: 'GET',
                    params: {
                        ...this.queryParams,
                        StartDate:
                            this.StartDate
                            || moment(+this.EndDate)
                                .startOf('year')
                                .format('x'),
                        EndDate: this.EndDate,
                        Account: this.accno,
                        poo: this.poo,
                    },
                    paramsSerializer: (params) => qs.stringify(params, { indices: false, skipNulls: true }),
                });

                console.log('QueryGeneralLedger', resp.data);
                this.datas = this.normalizeDataForDisplay(resp.data.items);
                this.totalDataCount = resp.data.totalNum;
            } finally {
                this.isLoading = false;
            }
        },
        normalizeDataForDisplay(rawItems) {
            const outputList = [];

            let lastAccno = null;
            for (let i = 0; i < rawItems?.length; i += 1) {
                const rawItem = rawItems[i];
                if (lastAccno !== rawItem.accno) {
                    // 是第一次遇到該科目
                    rawItem.firstAccno = true;
                    outputList.push(rawItem);
                    lastAccno = rawItem.accno;
                } else {
                    // 非第一次
                    const item = rawItem;
                    item.firstAccno = false;
                    outputList.push(item);
                }
            }
            return outputList;
        },
        rowClassName({ row }) {
            if (row.firstAccno) return 'first-accno-row';
            return 'normal-accno-row';
        },
        getChtDate(timestamp) {
            return `${moment(timestamp).year() - 1911}-${moment(timestamp).format('MM-DD')}`;
        },

        onVonoClick(vono, transactionType) {
            this.voucherDetail.visible = true;
            this.voucherDetail.vono = vono;
            this.voucherDetail.transactionType = transactionType;
        },
        onVoucherDetailCLose(refresh) {
            this.voucherDetail.visible = false;
            this.voucherDetail.vono = null;
            this.voucherDetail.transactionType = null;
            if (refresh) {
                this.isEdited = true;
                this.updateData();
            }
        },
    },
};
</script>

<style lang="scss">
.accounting-account-balance-spread-sheet {

    >.el-dialog {
        max-width: 1100px;
    }

    .summary {
        display: flex;
        margin-bottom: 20px;
        .info-block {
            &:not(:last-child) {
                margin-right: 30px;
            }
            .label {
                color: #aaa;
            }
        }
    }

    .accounting-general-ledger-table {
        border-bottom: 1px solid #ddd;

        .el-table__row {
            td {
                color: #000;
                font-size: 10pt;
                padding-top: 0;
                padding-bottom: 0;
                border-top: 1px solid #ddd;
                border-bottom: 0;

                &:nth-child(1),
                &:nth-child(2) {
                    border-top: transparent;
                    background-color: transparent;
                }
            }
        }
        .el-table__row.first-accno-row > td {
            border-top: 1px solid #000;
        }
    }

    .pagination {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        background-color: #fff;
    }
}
</style>
